// 盘点表状态
export default [
  { value: 1, label: "加1元" },
  { value: 2, label: "加2元" },
  { value: 3, label: "加3元" },
  { value: 4, label: "加4元" },
  { value: 5, label: "加5元" },
]